<template>
    <section>
        <h3>
            <span>
                <router-link class="board-card" :to="{ name: 'home' }">Mis Paneles</router-link>
            </span> > {{ name }}
        </h3>
        <v-text-field  class="input-box board-input" type="text" placeholder="Añade una lista" v-model="listName" @keydown.enter.prevent="add()" ></v-text-field>
     
        <div class="container">
            <column v-for="(list, index) in boardList" :key="'column-'+index" :listId="list.id" :name="list.name">
            </column>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Column from '@/components/Column.vue';
export default {
    name: 'board-view',
    components: { Column },
    props: {
        name: String,
        id: String
    },
    data() {
        return {
            listName: ''
        }
    },
    computed: {
        ...mapState(['fetchingData']),
        ...mapGetters(['getListsByBoard']),
        boardList() {
            return this.getListsByBoard(this.id)
        }
    },
    methods: {
        ...mapActions([
            'fetchLists',
            'addColumn'
        ]),

        add() {
            event.preventDefault();
            this.addColumn({ board: this.id, name: this.listName })
            this.listName = ''
        }
    },

    created() {
        this.fetchLists({ board: this.id })
    }
}
</script>
<style lang="scss" scoped>
section {
    text-align: left;
}

h3 {
    color: #37474f;
    text-align: left;
    margin: 1.5rem;

    span {
        color: #546e7a;
    }

    span .board-card {
        text-decoration: none;
        color: #37474f;

        &:hover {
            color: #90a4ae;
            font-weight: bold;
        }
    }
}

input {
    background-color: #607d8b;
    border: 0;
    border-radius: 3px;
    box-shadow: 0 0 0 0.5 rgba(49, 49, 93, .03),
        0 2px 5px 0 rgba(49, 49, 93, .1) 0 1px 2px 0 rgba(0, 0, 0, .08);
    color: #607d8b;
    font-size: 1.2rem;
    margin: 1rem;
    outline: 0;
    padding: 1rem;
    transition: all 600ms ease;

    &:active,
    &:focus {
        background-color: #fafafa;

    }

    &::placeholder {
        color: #fafafa;
    }
}
</style>